import BaseApiClient from '../BaseApiClient';
import { ListDataParams, ListDataResponse } from '../types';
import {
  MissionCreateUpdatePayload,
  MissionInterface,
  MissionTypeInterface
} from '@/interfaces/Missions.interface';

export class ApiMissions extends BaseApiClient {
  /**
   * Create mission
   */
  async create(payload: MissionCreateUpdatePayload): Promise<MissionInterface> {
    return new Promise((resolve, reject) => {
      this.client
        .post(`/missions`, payload, {
          headers: { Version: '2025-11-14' }
        })
        .then((res) => {
          if (res.data) {
            resolve(res.data.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  /**
   * Get mission
   */
  async get(missionId: number): Promise<MissionInterface> {
    return new Promise((resolve, reject) => {
      this.client
        .get(`/missions/${missionId}`, {
          headers: { Version: '2025-11-14' }
        })
        .then((res) => {
          if (res.data) {
            resolve(res.data.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  /**
   * Update mission
   */
  async update(
    missionId: number,
    payload: MissionCreateUpdatePayload
  ): Promise<MissionInterface> {
    return new Promise((resolve, reject) => {
      this.client
        .put(`/missions/${missionId}`, payload, {
          headers: { Version: '2025-11-14' }
        })
        .then((res) => {
          if (res.data) {
            resolve(res.data.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  /**
   * Delete mission
   */
  async delete(missionId: number): Promise<void> {
    return new Promise((resolve, reject) => {
      this.client
        .delete(`/missions/${missionId}`, {
          headers: { Version: '2025-11-14' }
        })
        .then((res) => {
          resolve();
        })
        .catch((err) => reject(err));
    });
  }
}

export { missionsQueryKeys } from './query-keys';
export { useMissionQuery } from './use-missions-queries';
export {
  useMissionCreateMutation,
  useMissionUpdateMutation,
  useMissionDeleteMutation
} from './use-missions-mutations';
export type { MissionUpdateVariables } from './use-missions-mutations';
